export class DataCatalogRowExpression {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "allOf",
            "baseName": "allOf",
            "type": "Array<DataCatalogRowExpression>",
            "format": ""
        },
        {
            "name": "anyOf",
            "baseName": "anyOf",
            "type": "Array<DataCatalogRowExpression>",
            "format": ""
        },
        {
            "name": "not",
            "baseName": "not",
            "type": "DataCatalogRowExpression",
            "format": ""
        },
        {
            "name": "predicate",
            "baseName": "predicate",
            "type": "DataCatalogRowPredicate",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogRowExpression.attributeTypeMap;
    }
    constructor() {
    }
}
